<template>
  <div class="text-center fixed-bottom">
    <!-- <p class="font-weight-bold">
      Powered By Arcadis -->
      <img src="assets/PoweredByArcadis.png" alt="" height="40"/>
    <!-- </p> -->
  </div>
</template>

<script>
export default {
  name: 'AppFooter',
  props: {
    msg: String
  }
}
</script>

<style>
</style>
